import { getUserStateFromLocalStorage } from "../contexts/AuthProvider/AuthProvider.utils";

export const getUserAuth = (): string | null => {
  const authState = getUserStateFromLocalStorage();
  if (authState) {
    return window.self !== window.top && authState.external_auth ? authState.external_auth.token :  authState.token;
  }
    return null;
  };
